import styled from 'styled-components';
import theme from 'theme/theme';
import Flex from '../Flex';

const Col = styled(Flex)
  .attrs((props) => ({
    flexBasis: props.flexBasis || 0,
  }))`
  padding-left:  ${theme.grid.gutter / 2}${theme.grid.unit};
  padding-right:  ${theme.grid.gutter / 2}${theme.grid.unit};
`;

export default Col;
